import React, { useEffect, useState } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import {
  makeStyles,
  withStyles,
  Box,
  Button,
  Typography,
} from "@material-ui/core";
//import Gradient from "javascript-color-gradient";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";

import LoaderView from "../../../components/LoaderView";
import { isEmptyObject } from "utils";
import {
  convertCamelToNormalCase,
} from "../components/utils";
import ApexCharts from "react-apexcharts";
import ReactDOMServer from 'react-dom/server';

const useStyles = makeStyles({});

const ActivityHoursByEmployee = (props) => {
  const {
    employeeActivityHoursData,
    employeeActivityHoursDataLoading,
    districtBuildingMapLoading
  } = props;

  const { employeeHoursData, employeeHoursTotalData } =
    employeeActivityHoursData;

  const classes = useStyles(),
    { t } = useTranslation();

  const [activityOptions, setActivityOptions] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState("");
  const [employeeActivityData, setEmployeeActivityData] = useState([]);
  const [employeeActivityDataToShow, setEmployeeActivityDataToShow] = useState(
    []
  );
  const [employeeActivityTotalData, setEmployeeActivityTotalData] = useState(
    []
  );
  const [isEmployeeActivityDataAvailable, setIsEmployeeActivityDataAvailable] =
    useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  //const [colorGradientArray, setColorGradientArray] = useState([]);

  const employeeDataRestrictedLength = 4;

  const buttonDisabled = (dataLength) => {
    if (dataLength < employeeDataRestrictedLength) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  };

  const onShow = () => {
    if (employeeActivityDataToShow.length === employeeDataRestrictedLength) {
      setEmployeeActivityDataToShow(employeeActivityData);
    } else {
      setEmployeeActivityDataToShow(
        employeeActivityData.slice(0, employeeDataRestrictedLength)
      );
    }
  };

  useEffect(() => {
    if (employeeActivityDataToShow.length === employeeDataRestrictedLength) {
      setEmployeeActivityDataToShow(employeeActivityData);
    } else {
      setEmployeeActivityDataToShow(
        employeeActivityData.slice(0, employeeDataRestrictedLength)
      );
    }
    console.log("setMidpoint", employeeActivityData.length);
    // const gradientArray = new Gradient()
    //   .setColorGradient("#02f7d2", "#03947e")
    //   .setMidpoint(1)
    //   .getColors();

    // setColorGradientArray(gradientArray);
  }, [employeeActivityData]);

  useEffect(() => {
    if (employeeHoursTotalData) {
      const activityOptionsList = Object.keys(employeeHoursTotalData).map(actName => employeeHoursTotalData[actName]?.translatedKey);
      console.log("activityOptionsList", activityOptionsList,employeeHoursTotalData)
      if (!isEmptyObject(activityOptionsList)) {
        setActivityOptions(activityOptionsList);
      } else {
        setActivityOptions([]);
        setSelectedActivity("");
      }
    }
  }, [employeeActivityHoursData]);

  useEffect(() => {
    if (employeeHoursData && employeeHoursTotalData) {
      const employeeData = employeeHoursData[convertCamelToNormalCase(selectedActivity)];
      const employeeTotalData = employeeHoursTotalData[convertCamelToNormalCase(selectedActivity)];
      if (employeeData && employeeTotalData) {
        employeeData.sort(
          (a, b) => parseFloat(b.activityHours) - parseFloat(a.activityHours)
        );
        buttonDisabled(employeeData.length);
        setEmployeeActivityData(employeeData);
        setEmployeeActivityTotalData([employeeTotalData]);
        setIsEmployeeActivityDataAvailable(true);
      } else {
        setIsEmployeeActivityDataAvailable(false);
      }
    } else {
      setIsEmployeeActivityDataAvailable(false);
    }
  }, [selectedActivity, employeeActivityHoursData]);

  const renderCustomizedLabelAssetCount = (props) => {
    const {
      x, y, width, height, value,
    } = props;

  const fireOffset =  isNaN(value) ;
  const offset = fireOffset ? -25 : 5;
  
    return (
        <text  x={fireOffset ? 135 : x+(width/2)} y={y + (height/2) + 5} fill = {isNaN(value) ? "black" : "white" } textAnchor="middle">
         {isNaN(value) ? 'NaN' : value}
       </text>
    );
  };
  const renderCustomizedLabel = (props) => {
    const {
      x, y, width, height, value,
    } = props;
 
  
  const fireOffset = value <= 0;
  const offset = fireOffset ? -25 : 5;
    return (
       <text fill={"white"} x={x + width - offset} y={y + (height/2) + 5} textAnchor="end">
         {Number(value) ? value: ""}
       </text>
    );
  };
  const CustomTooltipEmployee = ({series, seriesIndex, dataPointIndex, w}) => {
    const payload = [{payload: w.config.series[seriesIndex]?.['data']?.[dataPointIndex]}]
    if (payload && payload.length) {
      let perEff = Number(payload[0].payload.targetAph) > 0 && payload[0].payload.aph ? 
       Number(payload[0].payload.aph)/ Number(payload[0].payload.targetAph)  : 0;
      return (
        `${ReactDOMServer.renderToString(
        <Card variant="outlined">
          <CardContent> 
          {payload[0]?.payload?.targetAph > 0 &&
          <>
          <Typography variant="body1" component="div">
              {`Target APH : ${payload[0]?.payload?.targetAph}`}
            </Typography>
            </>
           }
            <Typography variant="body1" component="div">
              {`Duration : ${Number(payload[0].payload.activityHours).toFixed(2)} hrs`}
            </Typography>
            <Typography variant="body1" component="div">
              {`Asset Count : ${payload[0].payload.assetCount}`}
            </Typography>
           {Number(perEff) >0 && <Typography variant="body1"component="div">
              {`% Achievement : ${Number(perEff*100).toFixed(2)}%`}
            </Typography>}
          </CardContent>
        </Card>
        )}`
      );
    }

    return null;
  };

  const apexOptions = {
    chart: {
      height: 350,
      type: 'bar'
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '35',
        columnWidth: '40px'
      }
    },
    colors: ["#00a88e"],
    dataLabels: {
      offsetX: 10, // Position data labels at the end of bars
      textAnchor: "start",
      hideOverflowingLabels: false,
      formatter: function(val, opt) {
        const goals =
          opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
            .goals
    
        if (goals && goals.length) {
          return `${val} / ${goals[0].value}`
        }
        return val
      },
      style:{
        colors: ['#000'],
        fontSize: '14px',
        fontWeight: 700
      }
      // dropShadow: {
      //   enabled: true,
      //   opacity: 1,
      //   blur: 1,
      //   color: "#000",
      //   offsetX: 1,
      //   offsetY: 1,
      // },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'center',
      floating: true,
      show: true,
      showForSingleSeries: true,
      customLegendItems: ['Actual', 'Planned'],
      markers: {
        fillColors: ["#00a88e", '#775DD0']
      }
    },
    grid: {
      show: true
    },
    xaxis: {
      // categories: plannedActivityHoursData.length>0 ? 
      //             plannedActivityHoursData.map(item => t(`other.${item.x}`)) :[],
      labels: {
        // style: {
        //   fontSize : '14px'
        // },
        show: true
      },
      axisBorder: {
        show: true,  // Hide the axis line (border)
      },
      axisTicks: {
        show: true, // Hide x-axis ticks
      },
      title: {
        text: t("other.lblActionsperHour(APH)"),
      //  offsetY: -20,
        horizontalAlign: 'center',
      },
      min: 0,
    },
    yaxis: {
      labels: {
        style: {
          fontSize : '1rem'
        },
      },
      axisBorder: {
        show: true,  // Hide the axis line (border)
      },
    },
    tooltip: { 
      custom: CustomTooltipEmployee,
      followCursor: true,  // Makes the tooltip follow the cursor
      shared: false,       // Disable shared tooltip (individual tooltips for each series)
      fixed: true,
    }
  }

  return (
    <>
      <LoaderView
        loading={employeeActivityHoursDataLoading || districtBuildingMapLoading}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs="auto" style={{padding:"0px 16px 16px 16px"}} >
            <Autocomplete
              options={activityOptions}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  console.log("newValue", newValue)
                  setSelectedActivity(newValue);
                } else {
                  setSelectedActivity("");
                }
              }}

              value = {(selectedActivity !== "" ? t(`other.${selectedActivity}`) : "" )}
             renderOption={(value) => t(`other.${value}`)}
              style={{ width: 200 }}
              renderInput={(params) => {
                if (selectedActivity === "") {
                  return <TextField {...params}    label={t("other.lblSelectActivity")} />;
                } else {
                  return <TextField {...params}   label={t("other.activity")} />;
                }
              }}
            />
          </Grid>
          {isEmployeeActivityDataAvailable ? (
            <>
              <Grid item xs="auto">
                <Typography variant="h6">
                {t("other.lblAverageAPH")}
                  </Typography>
              </Grid>
              <Grid item xs="auto">
                <Typography variant="h6">
                  {employeeActivityTotalData[0].totalAph}
                </Typography>
              </Grid>
              {employeeActivityDataToShow[0]?.targetAph>0 &&
              <>
              <Grid item xs="auto">
                <Typography variant="h6">Target APH</Typography>
              </Grid>
              <Grid item xs="auto">
                <Typography variant="h6">
                  {employeeActivityDataToShow[0]?.targetAph}
                </Typography>
              </Grid>
              </>}
            </>
          ) : null}
        </Grid>

        {
          isEmployeeActivityDataAvailable ? (
          <div style={{  overflowY: ((employeeActivityDataToShow.length * 45)+120) >= 500 ? 'scroll' : 'hidden'}}>
          <ResponsiveContainer
            width="99%"
            height={(employeeActivityDataToShow.length * 45)+120}
            
          >
            {/* <BarChart
              data={employeeActivityDataToShow}
              margin={{ left: 50, top: 10, bottom: 10 }}
              layout="vertical"
              >
              <XAxis type="number" tick={false} axisLine={false} />
              <YAxis
                dataKey="employeeNameId"
                orientation="left"
                type="category"
                axisLine={false}
                tickLine={false}
                // width={100}
                yAxisId={0}
              />
              <YAxis
                dataKey="employeeNameId"
                orientation="left"
                type="category"
                axisLine={false}
                tickLine={false}
                hide
                yAxisId={1}
                // width={100}
              />
              <Tooltip cursor={{fill: 'transparent'}} content={<CustomTooltipEmployee />} />
              <Bar
                dataKey="targetAph"
                fill="#B2BEB5"
                yAxisId={1}
                //minPointSize={15}
              >
                   <LabelList dataKey="targetAph" content={renderCustomizedLabel} position="insideRight" style={{ fill: "black" }} />
              </Bar>
              <Bar
                dataKey="aph"
                //label={{ fill: "white", fontSize: 15, dataKey: "aph" }}
                fill="#00a88e"
                yAxisId={0}
                minPointSize={25}
              >
                <LabelList dataKey="aph"  content={renderCustomizedLabelAssetCount} />
              </Bar>
            </BarChart> */}
             <ApexCharts 
                options={apexOptions}
                series={[
                          {
                              name: 'Actual APH',
                              data: employeeActivityDataToShow
                            }
                          ]}
                type="bar"
                height={'100%'}
              />
          </ResponsiveContainer>
          </div>
        ) : (
          <Grid style={{ marginTop: "30px" }}>
            <Box className={classes.full}>
              <Alert severity="info">{t("other.errNoReportData3")}</Alert>
            </Box>
          </Grid>
        )}

        {/* {isEmployeeActivityDataAvailable ? (
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <Typography variant="h6">
              {t("other.lblActionsperHour(APH)")}</Typography>
            </Grid>
          </Grid>
        ) : null} */}
        {isEmployeeActivityDataAvailable && (
          <Button
            disabled={isButtonDisabled}
            onClick={() => {
              onShow();
            }}
            color="primary"
          >
            {employeeActivityDataToShow.length === employeeDataRestrictedLength
              ? t("other.lblShowMore")
              : t("other.lblShowLess")
            }
          </Button>
        )}
      </LoaderView>
    </>
  );
};

export default ActivityHoursByEmployee;
